<template>
  <div class="modal fade create-new-product-modal" id="CreateProductModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar produto</h1>
                  <button type="button" class="btn-close create-new-product-modal" data-bs-dismiss="modal" aria-label="Close" :disabled="galleryBusy"></button>
              </div>

              <form ref="formCreateProduct" @submit.prevent="createProductMethod">
                <div class="modal-body product-create-modal-body ps-30 pe-30">
                  <div class="product-create-tabs">
                    <ul
                      class="nav nav-tabs bg-white border-0 rounded-0 radius-7"
                      id="createProductTabs"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link fs-14 fs-md-15 fs-lg-16 fw-bold position-relative border-0 rounded-0 d-block w-100 active radius-7"
                          id="create-product-manual-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#create-product-manual-pane"
                          type="button"
                          role="tab"
                          aria-controls="create-product-manual-pane"
                          aria-selected="true"
                        >
                          <i class="flaticon-edit"></i>
                          <span class="d-none d-md-inline">Criar manualmente</span>
                          <span class="d-inline d-md-none">Manual</span>
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link fs-14 fs-md-15 fs-lg-16 fw-bold position-relative border-0 rounded-0 d-block w-100 radius-7"
                          id="create-product-csv-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#create-product-csv-pane"
                          type="button"
                          role="tab"
                          aria-controls="create-product-csv-pane"
                          aria-selected="false"
                        >
                          <i class="flaticon-zip-file"></i>
                          <span class="d-none d-md-inline">Criar via CSV</span>
                          <span class="d-inline d-md-none">CSV</span>
                        </button>
                      </li>
                    </ul>

                    <div id="createProductTabContent" class="tab-content product-tab-content">
                      <div
                        class="tab-pane fade show active"
                        id="create-product-manual-pane"
                        role="tabpanel"
                        tabindex="0"
                      >
                        <p>Preencha as informacoes abaixo para criar um produto</p>
                        
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                          <label for="name_product_created" class="form-label fw-medium"
                            >Nome</label
                          >
                          <input
                            type="text"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="name_product_created"
                            placeholder="Digite o nome do produto"
                            autocomplete="off"
                            required
                          />
                        </div>
                        
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                          <label for="sku_product_created" class="form-label fw-medium"
                            >SKU</label
                          >
                          <input
                            type="text"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="sku_product_created"
                            placeholder="Digite o SKU"
                            autocomplete="off"
                          />
                        </div>

                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                          <label for="description_product_created" class="form-label fw-medium"
                            >Descricao</label
                          >                      
                          <textarea
                            id="description_product_created"
                            type="text"
                            class="form-control shadow-none rounded-0 text-black radius-7"
                            placeholder="Digite a descricao"
                            rows="4"
                          ></textarea>
                        </div>

                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                          <label for="price_product_created" class="form-label fw-medium"
                            >Preco</label
                          >
                          <input
                            v-model="product_value"
                            type="text"
                            @input="maskMoney"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="price_product_created"
                            placeholder="Ex: 1.500,00"
                            autocomplete="off"
                            required
                          />
                        </div>

                        <ProductGalleryEditor v-model="productImages" @busy="galleryBusy = $event" />

                        <div class="custom-footer">
                          <button type="button" class="btn btn-danger create-new-product-modal" data-bs-dismiss="modal" :disabled="galleryBusy">Cancelar</button>
                          <button type="submit" ref="buttonCreateProduct" class="btn btn-success" :disabled="galleryBusy">
                            <span class="d-none d-md-inline">Criar produto</span>
                            <span class="d-inline d-md-none">Criar</span>
                          </button>
                        </div>
                      </div>

                      <div
                        class="tab-pane fade"
                        id="create-product-csv-pane"
                        role="tabpanel"
                        tabindex="0"
                      >
                        <div class="alert alert-info d-flex align-items-center fs-md-15 fs-lg-16 alert-csv-example top-custom" role="alert">
                          <i class="flaticon-telegram lh-1 fs-15 position-relative top-1 me-8"></i>
                          Importe um arquivo CSV para criar produtos em massa.
                          <a href="/produtos_exemplo.csv" download class="ms-1 fw-semibold text-decoration-underline">
                            (Baixar CSV de exemplo)
                          </a>
                        </div>

                        <div class="csv-fields-hint fs-14 text-muted mb-20">
                          Colunas esperadas: nome, sku, descricao, preco.
                        </div>

                        <div class="d-flex flex-column align-items-center bottom-custom">
                          <label for="product_csv_file_input" class="form-label fw-medium">Selecione um arquivo CSV:</label>
                          <input 
                            type="file" 
                            id="product_csv_file_input" 
                            ref="csvFile"
                            class="d-none" 
                            @change="onFileChange"
                            accept=".csv,text/csv"
                          >

                          <label for="product_csv_file_input" class="custom-file-upload">
                            {{ fileName || "Clique para selecionar um arquivo..." }}
                          </label>
                        </div>

                        <div class="custom-footer">
                          <button type="button" class="btn btn-danger create-new-product-modal" data-bs-dismiss="modal">Cancelar</button>
                          <button type="button" ref="buttonCreateProductByCsv" @click="sendCsvProducts" class="btn btn-success">
                            <span class="d-none d-md-inline">Criar produtos</span>
                            <span class="d-inline d-md-none">Importar</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCreateProduct" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateProduct">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import ProductGalleryEditor from './ProductGalleryEditor.vue';
import { catalogError } from '@/services/catalog';

export default {
  name: "CreateProductModal",
  components: { ProductGalleryEditor },
  data () {
    return {
        product_value: null,
        selectedFile: null,
        fileName: null,
        productImages: [],
        galleryBusy: false,
    }
  },
  methods: {
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.product_value = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.product_value = value;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.selectedFile = file;
      this.fileName = file ? file.name : null;
    },
    sendCsvProducts(){
      const buttonCreateProductByCsv = this.$refs.buttonCreateProductByCsv;

      if (!this.selectedFile) {
        this.alertResponse("Selecione um arquivo CSV para importar", true);
        return;
      }

      const fileExtension = this.selectedFile.name.split('.').pop().toLowerCase();
      if (fileExtension !== "csv") {
        this.alertResponse("O arquivo precisa estar no formato CSV", true);
        return;
      }

      const params = new FormData();
      params.append("csv_file", this.selectedFile);

      buttonCreateProductByCsv.disabled = true;
      buttonCreateProductByCsv.innerHTML = "Importando...";
      const alertResponse = this.alertResponse;

      api.axios.post("/api/products/csv", params, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).catch(function(error){
        buttonCreateProductByCsv.innerHTML = "Criar produtos";
        buttonCreateProductByCsv.disabled = false;
        alertResponse(error.response?.data?.message || error.response?.data || "Erro ao importar produtos", true);
      }).then(function(response){
        if(response != undefined && (response.status == 200 || response.status == 201)){
          const data = response.data || {};
          const created = data.created || 0;
          const updated = data.updated || 0;
          const ignored = data.ignored || 0;
          buttonCreateProductByCsv.innerHTML = `Importados: ${created} | Atualizados: ${updated} | Ignorados: ${ignored}`;
          setTimeout(() => {
            window.location.reload();
          }, 2200);
        } else {
          buttonCreateProductByCsv.disabled = false;
          buttonCreateProductByCsv.innerHTML = "Criar produtos";
        }
      });
    },
    createProductMethod(){
      const alertResponse = this.alertResponse;

      const name_product_created = document.getElementById("name_product_created").value;
      const sku_product_created = document.getElementById("sku_product_created").value;
      const description_product_created = document.getElementById("description_product_created").value;
      const price_product_created = document.getElementById("price_product_created").value;
      
      if(!name_product_created || !price_product_created){
        this.alertResponse("Por favor preencha todos os campos obrigatorios", true);
        return;
      }

      const objProductCreate = {
        "image_ids": this.productImages.map(image => image.id),
        "name": name_product_created,
        "sku": sku_product_created,
        "description": description_product_created,
        "price": price_product_created.replace(/\./g, '').replace(',', '.')
      }

      const buttonCreateProduct = this.$refs.buttonCreateProduct;
      buttonCreateProduct.disabled = true;
      buttonCreateProduct.innerHTML = "Criando...";
      

      api.axios.post("/api/products", objProductCreate).catch(function(error){
        if(error.response?.data != undefined){
          buttonCreateProduct.innerHTML = "Criar produto";
        }
        alertResponse(catalogError(error), true);
        buttonCreateProduct.disabled = false;
      }).then(function(response){
        
        if(response != undefined && (response.status == 200 || response.status == 201)){
          buttonCreateProduct.innerHTML = "Produto criado com sucesso !";
          window.location.reload();
        } else {
          buttonCreateProduct.disabled = false;
          buttonCreateProduct.innerHTML = "Criar produto";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateProduct").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateProduct").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateProduct");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    },
  }
};
</script>

<style scoped>
.product-create-tabs {
  margin-top: 10px;
}

.product-create-tabs :deep(.nav-tabs) {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 4px;
  background: #f6f7fb !important;
  border-radius: 8px;
}

.product-create-tabs :deep(.nav-tabs .nav-link) {
  min-height: 44px;
  border-radius: 6px !important;
  color: #6b7280;
  background: transparent;
  box-shadow: none;
}

.product-create-tabs :deep(.nav-tabs .nav-link i) {
  margin-right: 6px;
}

.product-create-tabs :deep(.nav-tabs .nav-link.active) {
  color: #ffffff;
  background: var(--splash-success-color);
  box-shadow: none;
}

.product-tab-content {
  padding: 18px 4px 4px;
}

.custom-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.custom-file-upload {
  padding: 10px 15px;
  border-radius: 6px;
  display: inline-block;
  cursor: pointer;
  background-color: #6560F0;
  color: #fff;
  width: fit-content;
  font-weight: bold;
  transition: 0.3s;
}

.custom-file-upload:hover {
  background: #474787;
}

.top-custom {
  margin-top: 30px;
}

.bottom-custom {
  margin-bottom: 40px;
}

@media (max-width: 767.98px) {
  .product-create-modal-body {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }

  .product-create-tabs {
    margin-top: 4px;
  }

  .product-create-tabs :deep(.nav-tabs) {
    gap: 6px;
    padding: 3px;
  }

  .product-create-tabs :deep(.nav-tabs .nav-link) {
    min-height: 36px;
    padding: 7px 8px;
    font-size: 13px !important;
    line-height: 1.1;
  }

  .product-create-tabs :deep(.nav-tabs .nav-link i) {
    margin-right: 4px;
  }

  .product-tab-content {
    padding: 14px 0 0;
  }

  .product-tab-content p {
    margin-bottom: 12px;
    font-size: 14px;
  }

  .product-tab-content .mt-30 {
    margin-top: 14px !important;
  }

  .custom-footer {
    gap: 8px;
    margin-top: 16px;
  }

  .custom-footer .btn {
    min-height: 38px;
    padding: 7px 12px;
    font-size: 14px;
    line-height: 1.2;
  }

  .top-custom {
    margin-top: 16px;
  }

  .bottom-custom {
    margin-bottom: 24px;
  }

  .custom-file-upload {
    max-width: 100%;
    padding: 9px 12px;
    font-size: 14px;
    text-align: center;
    overflow-wrap: anywhere;
  }
}
</style>
